<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M15 4c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm1 4h-3v1h3c.552 0 1 .448 1 1v4h-1v4h-2v-2h-1v2c0 .552.448 1 1 1h2c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707v-3c.552 0 1-.448 1-1V7c0-1.105-.895-2-2-2zM4 13v2H2v-4H1V7c0-.552.448-1 1-1h3V5H2C.895 5 0 5.895 0 7v4c0 .552.448 1 1 1v3c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-2H4zM3 4c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
      />
      <path fill="#FFF" d="M5 9H13V10H5z" />
      <path
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.5 11.5L4.5 9.5 6.5 7.5M11.5 7.5L13.5 9.5 11.5 11.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
